var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thrid-pay-result"},[_c('img',{staticClass:"payback-icon success-icon",attrs:{"src":require("@/assets/payResult/success.png")}}),_c('h1',{staticClass:"payback-title"},[_vm._v("支付成功")]),_c('hr'),_c('h2',{staticClass:"payback-tip"},[_vm._v("您已帮他付款")]),_c('img',{staticClass:"logo-more",attrs:{"src":require("@/assets/global/logo-more.png")}})])
}]

export { render, staticRenderFns }